/**
 * Analytics wrapper — PostHog in production, console everywhere.
 *
 * Set REACT_APP_POSTHOG_KEY in .env to enable PostHog:
 *   REACT_APP_POSTHOG_KEY=phc_xxxxxxxxxxxxxxxxxxxx
 *
 * PostHog API host: https://us.i.posthog.com  (US cloud)
 *                   https://eu.i.posthog.com  (EU cloud)
 */
import posthog from 'posthog-js';

const _key = process.env.REACT_APP_POSTHOG_KEY;

if (_key && process.env.NODE_ENV === 'production') {
  posthog.init(_key, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
    autocapture: false,      // manual events only — no click noise
    capture_pageview: false, // we fire page views via track()
    persistence: 'localStorage+cookie',
  });
}



// ── UTM CAPTURE + STORAGE ─────────────────────────────────────────────
function getUTM() {
  try {
    const stored = JSON.parse(localStorage.getItem("bm_utm") || "{}");

    const params = new URLSearchParams(window.location.search);

    const utm = {
      utm_source: params.get("utm_source") || stored.utm_source || "",
      utm_medium: params.get("utm_medium") || stored.utm_medium || "",
      utm_campaign: params.get("utm_campaign") || stored.utm_campaign || "",
      utm_content: params.get("utm_content") || stored.utm_content || "",
      utm_term: params.get("utm_term") || stored.utm_term || "",
      ref: params.get("ref") || stored.ref || "",
      landing_page: stored.landing_page || window.location.pathname,
      first_seen_at: stored.first_seen_at || new Date().toISOString()
    };

    // persist once (first touch wins)
    localStorage.setItem("bm_utm", JSON.stringify(utm));

    return utm;
  } catch (e) {
    return {};
  }
}

function getSessionId() {
  try {
    let sid = sessionStorage.getItem('bm_sid');
    if (!sid) {
      sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem('bm_sid', sid);
    }
    return sid;
  } catch (_) {
    return '';
  }
}

/** Fire a named analytics event with optional properties. */
export function track(event, props = {}) {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log('[analytics]', event, props);
  }
  if (_key) {
    posthog.capture(event, props);
  }
  // Fire-and-forget to our own backend regardless of PostHog key
  try {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('bm_auth_token') : null;
    const utm = getUTM();
    fetch('/api/analytics/event', {
      method: 'POST',
      keepalive: true,  // survives page navigation / component unmount
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ ...utm, ...props,
        event,
        session_id: getSessionId(),
        page:     props.page     || (typeof window !== 'undefined' ? window.location.pathname : ''),
        referrer: props.referrer || (typeof document !== 'undefined' ? document.referrer : ''),
        city:     props.city     || '',
        state:    props.state    || '',
        zip:      props.zip      || '',
      }),
    }).catch(() => {});
  } catch (_) {}
}
